// tslint:disable:max-line-length

import React from 'react';

export const ArrowCaretDown = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M7.152 11.6432C7.54367 12.2699 8.45633 12.2699 8.848 11.6432L12.0438 6.53C12.46 5.86395 11.9812 5 11.1958 5H4.80425C4.01881 5 3.53997 5.86395 3.95625 6.53L7.152 11.6432Z" />
    </svg>
  );
};
